<template>
    <div class="user-dialog">
        <el-form :model="user" label-width="80px" class="edit-form">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="账号:">{{ user.userId }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="用户名称:">{{ user.userName }}</el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="用户来源:">{{user.userPlatform}}</el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="注册时间:">{{ user.createTime | timeFilter }}</el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item label="账号状态:">
                        <span v-if="user.enable === 0">已禁用</span>
                        <span v-else-if="user.enable === 1" class="mr10">已启用</span>
                        <template v-if="[1, 2].includes(type)">
                            <el-button :disabled="user.enable === 1" type="text" @click="$emit('disablePermissionHandle', 1, user.$index, user)">启用</el-button>
                            <el-button disabled type="text">|</el-button>
                            <el-button :disabled="user.enable === 0" type="text" @click="$emit('disablePermissionHandle', 0, user.$index, user)">禁用</el-button>
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="type === 0">
                <el-col :span="24">
                    <el-tooltip :disabled="user.permissions && !user.permissions.length" class="item" effect="light" :content="user.permissions | userPermissionFilter('、')" placement="top-start">
                        <el-form-item label="可用权限:">{{ user.permissions | userPermissionFilter('、')}}</el-form-item>
                    </el-tooltip>
                </el-col>
            </el-row>
            <!-- 新增/编辑内容-->
            <template v-if="[1, 2].includes(type)">
                <el-form-item label="可用权限:" class="width100">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="checkAllChangeHandle">全选</el-checkbox>
                    <el-checkbox-group v-model="list" @change="checkedChangeHandle">
                        <div class="permission-group" v-for="group in permissionList" :key="group.title">
                            <template v-if="group.get.length || group.post.length || group.put.length || group.delete.length">
                                <h2 class="permission-group-title">{{group.title}}</h2>
                                <div v-if="group.get.length" class="flex-row">
                                    <div class="permission-group-option mr10">查看权限</div>
                                    <div class="permission-group-check">
                                        <el-checkbox v-for="permission in group.get" :label="permission" :key="permission.id">{{permission.name}}</el-checkbox>
                                    </div>
                                </div>
                                <div v-if="group.post.length" class="flex-row">
                                    <div class="permission-group-option mr10">新增权限</div>
                                    <div class="permission-group-check">
                                        <el-checkbox v-for="permission in group.post" :label="permission" :key="permission.id">{{permission.name}}</el-checkbox>
                                    </div>
                                </div>
                                <div v-if="group.put.length" class="flex-row">
                                    <div class="permission-group-option mr10">修改权限</div>
                                    <div class="permission-group-check">
                                        <el-checkbox v-for="permission in group.put" :label="permission" :key="permission.id">{{permission.name}}</el-checkbox>
                                    </div>
                                </div>
                                <div v-if="group.delete.length" class="flex-row">
                                    <div class="permission-group-option mr10">删除权限</div>
                                    <div class="permission-group-check">
                                        <el-checkbox v-for="permission in group.delete" :label="permission" :key="permission.id">{{permission.name}}</el-checkbox>
                                    </div>
                                </div>
                                <div v-if="group.funtions.length" class="flex-row">
                                    <div class="permission-group-option mr10">功能权限</div>
                                    <div class="permission-group-check">
                                        <el-checkbox v-for="permission in group.funtions" :label="permission" :key="permission.id">{{permission.name}}</el-checkbox>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </el-checkbox-group>
                </el-form-item>
            </template>
        </el-form>
    </div>
</template>

<script>
/*
 * @Author: daipeng
 * @Date: 2018-09-27 09:37:23
 * @LastEditTime: 2018-09-27 09:37:23
 * @Description: 用户设置设置 view/edit/add 弹出框
 * @Company: 成都二次元动漫
 */

export default {
    props: {
        user: Object,
        type: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            list: [],
            permissionList: [
                { title: '个人相关权限', get: [], delete: [], put: [], post: [], funtions: [] },
                { title: '漫画相关权限', get: [], delete: [], put: [], post: [], funtions: [] },
                { title: '管理员相关权限', get: [], delete: [], put: [], post: [], funtions: [] }
            ]
        };
    },
    created() {
        this.setChecked();
        this.getAllPermission();
    },
    computed: {
        // 左右的权限列表，方便全选按钮
        allPermission() {
            let result = [];
            this.permissionList.forEach(per => {
                const { get, post, put, funtions } = per;
                result = result.concat(get, post, put, funtions, per.delete);
            });
            return result;
        },
        checkAll: {
            get() {
                return this.list.length === this.allPermission.length;
            },
            set: () => {}
        },
        isIndeterminate: {
            get() {
                return this.list.length > 0 && this.list.length < this.allPermission.length;
            },
            set: () => {}
        }
    },
    watch: {
        user() {
            this.setChecked();
        },
        allPermission() {
            this.setChecked();
        }
    },
    methods: {
        setChecked() {
            let result = [];
            if (this.user.permissions) {
                this.user.permissions.forEach(item => {
                    this.allPermission.some(per => {
                        if (per.code === item.code) {
                            result.push(per);
                            return true;
                        }
                    });
                });
            }
            this.list = result;
        },
        // 全选
        checkAllChangeHandle(val) {
            this.list = val ? this.allPermission : [];
            this.isIndeterminate = false;
        },
        // 单选事件
        checkedChangeHandle(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.allPermission.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.allPermission.length;
        },
        /**
         * 获取所有的权限列表
         * relationType 权限类型    1个人相关/2漫画相关/3管理员相关
         * method   行为类型    get查询/post新增/put修改/delete删除/funtions功能
         */
        getAllPermission() {
            return this.$api('getUserPermissionList', { pageIndex: 1, pageSize: 500 }).then(res => {
                const permissions = this.$utils.cloneDeep(this.permissionList);
                res.data.rows.forEach(row => {
                    const { relationType, method } = row;
                    permissions[relationType - 1][method || 'funtions'].push(row);
                });
                this.permissionList = permissions;
            });
        }
    }
};
</script>

<style lang="scss">
    .user-dialog{
        padding: 20px;
        .el-form-item__content{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            span{
                font-size: 14px;
            }
        }
        .permission-group{
            &-title{
                font-size: 16px;
            }
            &-option{
                font-size: 14px;
            }
            &-check{
                flex-grow: 1;
                display: flex;
                flex-flow: row wrap;
                .el-checkbox{
                    margin-left: 0;
                    margin-right: 30px;
                }
            }
        }
    }
</style>
